module.exports = __webpack_public_path__ + "img/skaraton.d977ec51.jpg";